import classNames from 'classnames';
import React__default from 'react';
import { toast as toast$1, Zoom } from 'react-toastify';
import './_toastify-overrides.scss.js';
import { ReactComponent as SvgBidSuccessful } from '../../icons/BidSuccessful.svg.js';
import { ReactComponent as SvgError } from '../../icons/Error.svg.js';
import { ReactComponent as SvgInfo } from '../../icons/Info.svg.js';
import { ReactComponent as SvgWarning } from '../../icons/Warning.svg.js';
import Styles from './Toast.module.scss.js';

const DefaultToastOptions = {
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    pauseOnFocusLoss: true,
    draggable: false,
    closeButton: false,
    transition: Zoom,
    position: "bottom-center"
};
const IconMap = {
    success: SvgBidSuccessful,
    warning: SvgWarning,
    error: SvgError,
    info: SvgInfo
};
const MsgComp = ({ msg, className, contentClassName, type }) => {
    const Icon = IconMap[type];
    return (React__default.createElement("div", { className: classNames(Styles.main, className) },
        React__default.createElement("div", { className: Styles.icon },
            React__default.createElement(Icon, null)),
        React__default.createElement("div", { className: classNames(Styles.content, contentClassName) }, msg)));
};
const toast = (function () {
    function getComp(type, msg, options) {
        return (options === null || options === void 0 ? void 0 : options.shouldOverrideDefaultComp) ? (React__default.createElement(React__default.Fragment, null, msg)) : (React__default.createElement(MsgComp, { type: type, msg: msg, className: options === null || options === void 0 ? void 0 : options.className, contentClassName: options === null || options === void 0 ? void 0 : options.contentClassName }));
    }
    function toast(msg, options) {
        return toast$1.info(getComp("info", msg), Object.assign(Object.assign({}, DefaultToastOptions), options));
    }
    toast.info = function (msg, options) {
        return toast(msg, options);
    };
    toast.success = function (msg, options) {
        return toast$1.success(getComp("success", msg), Object.assign(Object.assign({}, DefaultToastOptions), options));
    };
    toast.error = function (msg, options) {
        return toast$1.error(getComp("error", msg), Object.assign(Object.assign({}, DefaultToastOptions), options));
    };
    toast.warning = function (msg, options) {
        return toast$1.warning(getComp("warning", msg), Object.assign(Object.assign({}, DefaultToastOptions), options));
    };
    toast.dismiss = function (id) {
        return toast$1.dismiss(id);
    };
    return toast;
})();

export { toast };
//# sourceMappingURL=toast.js.map
